import { PageContent } from "../pages/templates/PageLayout";

import Images from "../data/images";
import featureCards from "./featureCards";
import { MarketingActions } from "../hooks/useMarketingActions";

const content: PageContent = {
  style: "dark",
  sections: [
    {
      type: "HeroSection",
      title: "The visual home for your brand",
      subtitle: `
Use Lingo to create a central hub for your brand.

Digital brand guidelines and asset management brought together into one easy to use and affordable platform.
      `,
      style: "dark",
      image: {
        src: Images.Home.hero,
        alt: "Slide 1",
      },
      primaryButton: {
        text: "Try lingo for free",
        link: "/signup",
      },
      secondaryButton: {
        text: "Book a demo",
        action: MarketingActions.BOOK_DEMO,
      },
    },
    { type: "CustomerLogosSection" },
    {
      type: "MediaSection",
      title: "Define your brand",
      subtitle:
        "Lingo's easy to build kits are part document, part asset library. Use them to showcase every asset and aspect of your brand.",
      image: {
        src: Images.Home.defineBrand,
        alt: "Slide 1",
      },
    },
    {
      type: "MediaSection",
      title: "Empower teams to create on their own",
      subtitle:
        "With Lingo, every team member will be able to find the file they need, in the format and size they need all without needing your help.",
      layoutDirection: "image-left",
      image: {
        src: Images.Home.empowerTeams,
        alt: "Slide 1",
      },
    },
    {
      type: "MediaSection",
      title: "Always up to date",
      subtitle:
        "Lingo connects with the tools you use everyday so your assets are always up to date. Learn more about our Figma integration.",
      image: {
        src: Images.Home.upToDate,
        alt: "Slide 1",
      },
      primaryButton: {
        text: "Learn more about Figma & Lingo",
        link: "/integrations/figma",
      },
    },
    {
      type: "CardSection",
      title: "More features to help manage your brand",
      items: [
        featureCards.search,
        featureCards.customBranding,
        featureCards.fileConversions,
        featureCards.kitVersioning,
        featureCards.publicSharing,
        featureCards.customDomains,
      ],
      footerButton: {
        text: "View all features",
        buttonStyle: "outline",
        link: "/product/features",
      },
    },
    {
      type: "ShowcaseSection",
      title: "Showcase your brand in Lingo",
      image: {
        src: Images.Home.showcase,
        alt: "Slide 1",
      },
    },
  ],
};

export default content;
